import mapResponseToLimit from '../mappers/mapResponseToLimit'
import { IData } from './response'

export default async function(response: Response) {
  const json: IData = await response.json()
  const license = json.items.map(mapResponseToLimit)

  return license
}
